// firebase/config.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCK13INI6YEUg22IjpvinRykYcvT7qJdIA",
  authDomain: "modular-canto-399704.firebaseapp.com",
  projectId: "modular-canto-399704",
  storageBucket: "modular-canto-399704.firebasestorage.app",
  messagingSenderId: "882532614913",
  appId: "1:882532614913:web:3194dab7a03a50cc1e5100"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
